import { render } from "./StockRecord.vue?vue&type=template&id=27493271&scoped=true"
import script from "./StockRecord.vue?vue&type=script&lang=js"
export * from "./StockRecord.vue?vue&type=script&lang=js"

import "./StockRecord.vue?vue&type=style&index=0&id=27493271&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27493271"]])

export default __exports__